import { Grid, Typography } from "@mui/material";
import { FormEventHandler } from "react";
import { Field, Form } from "react-final-form";
import ErreursConstante from "../../../_constantes/erreursConstantes.json";
import Bouton from "../../../components/Button/Bouton";
import FormContainer from "../../../components/FormContainer";
import InputField from "../../../components/input/InputField";
import InputPassword from "../../../components/input/InputPassword";
import Select from "../../../components/select/Select";
import { isEmail, isMotDePasse } from "../../../helpers/validators";
import { Profil, Utilisateur } from "../../../services/Api/swagger/api.js";
import { construireListProfilsBesse } from "../helpers";

interface UtilisateurFormErrors {
  nom?: string;
  prenom?: string;
  mail?: string;
  profilBesse?: string;
  motDePasse?: string;
  confirmationMotDePasse?: string;
}

export interface UtilisateurBesseFormData {
  identifiant: string;
  nom: string;
  prenom: string;
  mail: string;
  profilBesse: string;
  motDePasse?: string;
  confirmationMotDePasse?: string;
}

interface CustomProps {
  // formValues: UtilisateurBesseFormData;
  formErrors?: UtilisateurFormErrors;
  classes?: any;
  handlePrecedent(): void;
  utilisateurBESSE?: boolean;
  profilsBesse?: Profil[];
  isFetching: boolean;
  initialValues?: UtilisateurBesseFormData;
  isModify?: boolean;
  onSubmit(values: UtilisateurBesseFormData): void;
}

function UtilisateurBesseForm({
  profilsBesse,
  isFetching,
  isModify,
  onSubmit,
  handlePrecedent,
  initialValues,
}: CustomProps) {
  const optionsProfilsBesse =
    profilsBesse && construireListProfilsBesse(profilsBesse);

  return (
    <Form
      validate={(values: UtilisateurBesseFormData | Utilisateur) =>
        validateForm(values, isModify)
      }
      name="utilisateurBesseForm"
      onSubmit={onSubmit}
      initialValues={initialValues}
      keepDirtyOnReinitialize={true}
    >
      {({ handleSubmit, pristine, submitting, form, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <FormContainer>
            <Grid container spacing={1}>
              <Grid item>
                <Field name="nom" component={InputField} label="Nom" required />
              </Grid>
              <Grid item>
                <Field
                  name="prenom"
                  component={InputField}
                  label="Prénom"
                  required
                />
              </Grid>
              <Grid item>
                <Field
                  name="mail"
                  component={InputField}
                  label="E-mail"
                  required
                  size={50}
                />
              </Grid>
            </Grid>

            {!isModify && (
              <Grid container spacing={1}>
                <Grid item>
                  <Field
                    label="Mot de passe"
                    name="motDePasse"
                    component={InputPassword}
                    type="password"
                    required
                  />
                </Grid>
                <Grid item>
                  <Field
                    label="Confirmation de votre mot de passe"
                    name="confirmationMotDePasse"
                    component={InputPassword}
                    type="password"
                    size={25}
                    required
                  />
                </Grid>
              </Grid>
            )}

            {!isModify && (
              <Grid container spacing={0}>
                <Typography style={{ marginTop: "-8px" }} variant="caption">
                  Le mot de passe doit avoir au moins 8 caractères, 1 majuscule,
                  1 minuscule et 1 chiffre.
                </Typography>
              </Grid>
            )}
            <Grid container spacing={1}>
              <Grid item>
                {optionsProfilsBesse && (
                  <Field
                    name="profilBesse"
                    component={Select}
                    label="Profil Bessé"
                    options={optionsProfilsBesse}
                    required
                  />
                )}
              </Grid>
            </Grid>
          </FormContainer>

          <Grid container justifyContent="space-between">
            <Grid item>
              <Bouton
                label="Annuler"
                variant="contained"
                color="inherit"
                size="medium"
                type="submit"
                onClick={handlePrecedent}
              />
            </Grid>
            <Grid item>
              <Bouton
                fetching={isFetching}
                label="Enregistrer"
                variant="contained"
                color="primary"
                size="medium"
                type="submit"
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
}

/**
 * Méthode de validation du formulaire
 * @param values
 */
const validateForm = (
  values: UtilisateurBesseFormData | Utilisateur,
  isModify?: boolean
): UtilisateurFormErrors => {
  const errors: UtilisateurFormErrors = {} as UtilisateurFormErrors;

  if (!values.nom) {
    errors.nom = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if (!values.prenom) {
    errors.prenom = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if (!values.mail) {
    errors.mail = ErreursConstante.formulaire.generale.champObligatoire;
  } else if (values.mail && values.mail && !isEmail(values.mail)) {
    errors.mail = ErreursConstante.formulaire.generale.emailIncorrect;
  }
  if (!values.profilBesse) {
    errors.profilBesse = ErreursConstante.formulaire.generale.champObligatoire;
  }
  if ((!values.motDePasse || !isMotDePasse(values.motDePasse)) && !isModify) {
    errors.motDePasse = ErreursConstante.formulaire.generale.motPasse;
  }

  if (
    values.motDePasse !==
      (values as UtilisateurBesseFormData).confirmationMotDePasse &&
    !isModify
  ) {
    errors.confirmationMotDePasse =
      ErreursConstante.formulaire.generale.confirmationMotPasse;
  }
  return errors;
};

export default UtilisateurBesseForm;
